













import {IFilterItem} from '../../models/filter-item-model';
import {defineComponent, PropType} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: 'Checkbox',
  props: {
    item: {type: Object as PropType<IFilterItem>}
  },
  methods: {
    checked(codename: string): boolean {
      return this.$store.state.filter.activeFilterItems.includes(codename)
          || this.$store.state.scope.activeScopeItems.includes(codename);
    }
  },
  setup: () => {
    const {labels} = useGetters(['labels'])

    return {
      labels
    }
  }
})
